export enum AnalyticsEvents {
  CLICK_BUTTON = 'ClickButton',
}
